/** Tudo o que não é letra, número ou espaço vira separador. */
const NAO_ALFANUMERICO = /[^a-z0-9]+/g;

const ACENTOS = /\p{Diacritic}/gu;

const HIFENS_DAS_PONTAS = /^-+|-+$/g;

/**
 * O nome de um serviço convertido na rota que o portal usa — 'AGENDAMENTO DE CONSULTA'
 * vira 'agendamento-de-consulta'.
 *
 * É o que liga o catálogo público da API, que identifica o serviço por `codServicoSrv`,
 * à rota `/:rotaPagina` do portal, que é um slug legível. A URL fica compreensível para
 * o cidadão e indexável, ao custo de mudar se o serviço for renomeado no adm — o mesmo
 * compromisso que as rotas estáticas já assumem.
 *
 * ⚠️ Dois serviços com o mesmo nome produzem o mesmo slug. Hoje o nome é texto livre no
 * cadastro e nada impede a repetição; se isso acontecer, o portal abre o primeiro. A
 * alternativa seria rota por id, que foi recusada por ser ilegível.
 *
 * É também o slug da **categoria** em `/servicos/:categoria` (desde 29/09/2026): a mesma
 * regra gera o link do card em "Categorias de Serviços" e o compara em "Todos os
 * Serviços". Uma regra só, para que as duas pontas nunca divirjam — e com o mesmo aviso
 * sobre homônimos, porque o nome da categoria também não é único no adm.
 */
export function slugDeServico(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(ACENTOS, '')
    .toLowerCase()
    .replace(NAO_ALFANUMERICO, '-')
    .replace(HIFENS_DAS_PONTAS, '');
}

/**
 * O texto sem acento, em caixa baixa e aparado — a comparação "sem caixa e sem acento" da
 * busca do portal (selo "Mais relevante", faixa de relevância e casamento das páginas),
 * a mesma régua que a API aplica por collation. É o primeiro passo do `slugDeServico`.
 */
export function normalizarTexto(texto: string): string {
  return texto.normalize('NFD').replace(ACENTOS, '').toLowerCase().trim();
}
